export const isValidRedirectUrl = (url) => {
    if (!url) return false

    // Allow relative URLs (always safe)
    if (url.startsWith('/') && !url.startsWith('//')) return true

    return false
}


export const getRedirectUrl = () => {
    const redirectParam = new URLSearchParams(window.location.search).get('redirect')
    if (!redirectParam) return null

    try {
        const decodedUrl = decodeURIComponent(redirectParam)
        return isValidRedirectUrl(decodedUrl) ? decodedUrl : null
    } catch {
        return null
    }
}

export const buildLoginUrl = (redirectUrl) => {
    if (!redirectUrl || redirectUrl === '/') {
        return '/auth/signin'
    }
    return `/auth/signin?redirect=${encodeURIComponent(redirectUrl)}`
}